import { useEffect } from 'react';
import { updateSelectedUTC } from '@alltrails/conditions/redux/conditionsSlice';
import { millisecondsInMinute } from '@alltrails/data-formatting/dateConstants';
import { useAppDispatch, useAppSelector } from '@/utils/redux';

export const exploreConditionsIntervalMin = 30;
export const exploreConditionsIntervalMs = exploreConditionsIntervalMin * millisecondsInMinute;

const useExploreConditions = () => {
  const dispatch = useAppDispatch();
  const activeCondition = useAppSelector(state => state.conditions.activeCondition);
  const isConditionActive = Boolean(activeCondition);

  useEffect(() => {
    if (isConditionActive) {
      const selectedUTC = Math.floor(Date.now() / exploreConditionsIntervalMs) * exploreConditionsIntervalMs;
      dispatch(updateSelectedUTC(selectedUTC));
    }
  }, [dispatch, isConditionActive]);
};

export default useExploreConditions;
